export const doLogin = (account) => ({
  type:"LOGIN",
  account
})

export const doLogout = () => ({
  type:"LOGOUT"
})



// WEBPACK FOOTER //
// ./src/actions/login.js